import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import { api } from "../../../utils/api";

function ViewAdmin(props) {
  const [valueEdit, setValueEdit] = useState(false);
  const [modulename, setModuleName] = useState(null);

  console.log("first", props?.indexView);
  useEffect(() => {
    axios
      .put(
        `${api}/auth/getPermissionsById`,
        {},
        {
          params: {
            Id: props.indexView?.role?.allowed_permissions, // Pass as query parameter
          },
        }
      )
      .then((res) => {
        console.log("resforPermission", res.data.data.name);
        setModuleName(res.data.data.name);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, [valueEdit, props.indexView]);

  console.log(props.values, "propsvalue");
  // const Edit =()=>{
  //   setEdit(true);
  //   setValueEdit(true);
  //   //  props.setValues(false);
  // }

  console.log("module", props.indexView);

  console.log(props.indexView, props.indexView, "for view user");
  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.6rem",
        height: "100%",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {/* <AddUser setValue={setValueEdit}
          value={valueEdit}
        index={props.indexView?._id}/> */}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={
            () => props.setValues(false)
            // setViewInner(false)
          }
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          View User Details
        </Typography>

        <Box >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Date
            </Typography>

            <p>
              {props.indexView && props.indexView.createdAt
                ? new Date(props.indexView.createdAt).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                    }
                  )
                : ""}
            </p>
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Company Name
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.indexView?.company?.companyName ?? ""}
        </p>
            <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
              Country
            </Typography>
            <p>{props.indexView?.country ?? ""}</p>
          </Box>
        

       
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Nickname
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.indexView?.name ?? ""}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Mobile No.
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.indexView
            ? ` ${props.indexView.countryCode + " " ?? ""} ${props.indexView.phone}`
            : ""}
        </p>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Email ID
        </Typography>
        <p>
          {/* {props.index?.role?.map((item) => item.name).join(', ') ?? ""} */}
          {props.indexView?.email ?? "-"}
        </p>
       

        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={props.handleEdit}
          >
            Edit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      {/* <Drawer
               sx={{
                // height:"106vh",
                backgroundColor: "transparent",
            '& .MuiDrawer-paper': { // This targets the paper component within the Drawer
                   backgroundColor: "transparent", // Make paper transparent
                   boxShadow: 'none', // Optional: Remove any shadow
                 }
             }}
                anchor="right"
                open={props.values}
                onClose={() => props.setValues(false)}
              >
                // {list()}
              </Drawer> */}

      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            // This targets the paper component within the Drawer
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.values}
        onClose={() => props.setValues(false)} // Close the drawer
      >
        {list()}
      </Drawer>
      {/* )} */}
    </div>
  );
}

export default ViewAdmin;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
